document.addEventListener('DOMContentLoaded', function(e) {
	const searchOverlay = document.querySelector('.o-search');

	if (searchOverlay) {
		const searchReveal = document.querySelector('.m-search__reveal');
		const searchClose = searchOverlay.querySelector('.a-search__close-button');

		const searchShowHide = function() {
			if (searchOverlay.classList.contains('show')) {
				searchOverlay.classList.remove('show');
			} else {
				searchOverlay.classList.add('show');
			}
		};

		searchReveal.addEventListener('click', function(e) {
			searchShowHide();
		});

		searchClose.addEventListener('click', function(e) {
			searchShowHide();
		});
	}
});
